export default [
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "from",
        placeholder: "DATE",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: { year: 'numeric', month: '2-digit', day: 'numeric' },
        cols: 6,
    },
    {
        type: "b-form-datepicker",
        margin: true,
        showLabel: true,
        label: "to",
        placeholder: "DATE",
        class: "font-small-2",
        model: null,
        locale: "es",
        dateFormatOptions: {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        },
        cols: 6,
    },
];